export default __webpack_public_path__ + "static/media/A0001.c4910c75.png";